import { render, staticRenderFns } from "./MainLedgerCard6.vue?vue&type=template&id=33408cb7"
import script from "./MainLedgerCard6.vue?vue&type=script&lang=js"
export * from "./MainLedgerCard6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports